import { booker } from './feature.booker.svelte.js';
import * as debug_actions from '../debug/actions_debug.svelte.js';
import DataLayerUtil from '../../utils/DataLayerUtil.js';
import * as booker_actions from './actions_booker.svelte.js';
import * as booking_actions from '../booking/actions_booking.svelte.js';
import * as booker_update from './booker.scenarios.update.svelte.js';
import DebugUtil from '../../utils/DebugUtil.js';
import DataUtil from '../../utils/DataUtil.js';
import { page_json, progress } from './../progress/feature.progress.svelte.js';
import * as booking_update from './../booking/booking.scenarios.update.svelte.js';


export function bookerDataStoreReq(oFormInput)
{
  debug_actions.debugAddLogFlow('booker', 'bookerDataStoreReq', { oFormInput });
  // console.log('reducer_booker - update booker info');
  // laat formulierdata de bestaande data in store overschrijven.. het is belangrijk dat de keys in getInitialBookerState gelijk zijn aan die in de state van UiBlockContentFormContainer
  // de reden dat we ook state bijhouden in dat component is zodat we niet bij elke keypress (change event) de store aanspreken en dus de hele applicatie updaten.. alleen onBlur
  //mState.mergeIn(['booker'], oFormInput);

  booking_actions.handleBookingUpdated('bookerDataStoreReq');
}

export function setInsurance(bInsurance)
{
  debug_actions.debugAddLogFlow('booker', 'setInsurance', { bInsurance: bInsurance });

  booker.bInsurance = bInsurance;

  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();
  booking_actions.handleBookingUpdated('FormPayment');
}

export function setPaymentMethod(sPreferredPaymentMethod)
{
  debug_actions.debugAddLogFlow('booker', 'setPaymentMethod', { preferredPaymentMethod: sPreferredPaymentMethod });

  booker.sPaymentMethod = sPreferredPaymentMethod;

  booking_update.evaluateCurrentEntryProductsAfterTimeOrPaymentMethodChange();
  booking_actions.handleBookingUpdated('paymentmethod');
}

export function setWantToLoginToFalse()
{
  debug_actions.debugAddLogFlow('booker', 'setWantToLoginToFalse');
  booker.bWasAskedToLogin = true;
  DataLayerUtil.eventSkipLogIn(false);
}

export function setPaymentBrand(paymentBrand)
{
  alert('als het goed is bestaat dit niet meer.. dit waren de iDeal banken');
  // debug_actions.debugAddLogFlow('booker', 'setPaymentBrand', {paymentBrand});
  // booker.sPaymentBrand = paymentBrand;
}

export function goToScreenLogin()
{
  debug_actions.debugAddLogFlow('booker', 'goToScreenLogin');
  booker.bIsThereARemoteAcountWithCurrentEmail = false;
  booker.sLastRemoteCheckedEmailAddress = '';
  booker.bWasAskedToLogin = false;
  //closeMagnificPopup();
}

export function clearEmail()
{
  debug_actions.debugAddLogFlow('booker', 'clearEmail');
  booker.bIsThereARemoteAcountWithCurrentEmail = false;
  booker.sEmail = '';
  booker.sLastRemoteCheckedEmailAddress = '';
  //closeMagnificPopup();
}

export function stayLoggedIn()
{
  debug_actions.debugAddLogFlow('booker', 'apiCallPackageDealsSuccess');
  booker.bStayLoggedIn = true;
}

export function subscribeToMailingListSuccess()
{
  debug_actions.debugAddLogFlow('booker', 'subscribeToMailingListSuccess');
  booker.bNewsletterIsSubscribed = true;
}

export function subscribeToMailingListFailure()
{
  debug_actions.debugAddLogFlow('booker', 'subscribeToMailingListFailure');
  booker.bNewsletterIsSubscribed = false;
}

export function testFillBooke()
{
  debug_actions.debugAddLogFlow('booker', 'testFillBooke');
  const parts = ['j', 'o', 'c', 'h', 'e', 'm'];
  const name = parts.join('');
  parts.push(Math.random().toString());
  const email = `${parts.join('')}@hamaka.nl`;
  const testBooker = {
    sTitle: 'Dhr.',
    sName1: parts.join(''),
    sName2: 'van',
    sName3: 'Hamaka',
    sEmail: email,
    sTel: '0612345678',
    sPostalcode: '3514AM',
    sHouse1: '99',
    sHouse2: '',
    sStreet: 'Wittevrouwensingel',
    sTown: 'Utrecht',
    sComments: 'Dit is een test',
    bWantsAccount: false,
    bInsurance: false,
    bNewsletter: true,
    bTerms: true
  };
}

export function handleCustomerIDSuccess(jsonInput)
{
  booker.bDidLoginFail = false;
  debug_actions.debugAddLogFlow('booker', 'handleCustomerIdSuccess', { jsonInput });
  booker.bWasAskedToLogin = true;
  // booker.bIsLoggedInLockForm = true;
  DataLayerUtil.bForceSetLoggedInTrue = true;
  DataLayerUtil.eventLoggedIn();
  booker_actions.setLoggedInCustomerData(jsonInput);
}

export function handleCustomerIDInvalid()
{
  booker.bDidLoginFail = true;
  debug_actions.debugAddLogFlow('booker', 'handleCustomerIdInvalid');
  booker.bWasAskedToLogin = false;
}

export function setLoggedInCustomerData(jsonInput)
{
  debug_actions.debugAddLogFlow('booker', 'setLoggedInCustomerData', { jsonInput });
  booker_actions.importFromCustomerDataAjaxCall(jsonInput);
  progress.iFormComponentRefreshCounter += 1;
}

export function importFromCustomerDataAjaxCall(jsonInput)
{
  if ( typeof jsonInput === 'undefined' )
  {
    DebugUtil.log('customer json undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
  }
  else
  {
    let oInput = jsonInput;
    let oParsedInput = DataUtil.isJsonString(jsonInput);
    if ( oParsedInput !== false ) oInput = oParsedInput;

    if ( oInput !== false )
    {
      booker_update.importFromObject(oInput);
    }
  }
}

export function importFromPageConfigAjaxCall()
{
  if ( typeof page_json.data.jsonHmkAccountConfig !== 'undefined' && page_json.data.jsonHmkAccountConfig !== 'false' && page_json.data.jsonHmkAccountConfig !== false )
  {
    let oInput = page_json.data.jsonHmkAccountConfig;
    let oParsedInput = DataUtil.isJsonString(oInput);
    if ( oParsedInput !== false ) oInput = oParsedInput;

    if ( oInput !== false )
    {
      booker_update.importFromObject(oInput);
    }
  }
}